module.exports = __webpack_public_path__ + "static/media/hive.f402c8f6.svg";